export enum EReviewsElementBlock {
  PAGE_SECTION = 'reviewsBlock',
  FORM = 'reviewModalWindow',
}
